"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerBasketItem = void 0;
var _components = require("../components");
var _context = require("../context");
var _BasketItemRoot = require("./BasketItemRoot");
var _InnerBasketItemBundle = require("./InnerBasketItemBundle");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const InnerBasketItem = ({
  data
}) => {
  const {
    itemTestId,
    isBundle,
    isSmall,
    isLoading
  } = data;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_context.ItemProvider, {
    value: data,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_BasketItemRoot.BasketItemRoot, {
      itemTestId: itemTestId,
      isBundle: isBundle,
      isBundleItem: false,
      isSmall: isSmall,
      isLoading: isLoading,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ItemImage, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ItemDescription, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ItemCostBenefit, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ItemActions, {}), isBundle ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerBasketItemBundle.InnerBasketItemBundle, {}) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Separator, {})]
  });
};
exports.InnerBasketItem = InnerBasketItem;
//# sourceMappingURL=InnerBasketItem.js.map